// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__MSy8k","inner":"Footer_inner__3dY6w","nextIcon":"Footer_nextIcon__3DAIa","innerLeft":"Footer_innerLeft__3lymf"};